
import React from 'react';
import { EditorState, ContentState, AtomicBlockUtils, convertFromRaw, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import ImageSlicer from "./ImageSlicer";

class EditorContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            oldSrc: null,
            isFrameUpdated: false,
        };
    }

    componentDidMount() {
        this.htmlSet()
        // this.createTopMenu();
    }



    componentDidUpdate(p) {
        // if (!p.topMenu && this.props.topMenu) {
        //     this.createTopMenu();
        // }

        if (!p.value && this.props.value) {
            this.htmlSet();
        }
    }

    htmlSet = () => {
        const blocksFromHtml = htmlToDraft(this.props.value);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        this.setState({ editorState: EditorState.createWithContent(contentState) })
    }

  
    onEditorStateChange = (editorState) => {
        this.setState({ editorState }, () => {
            const rawContentState = convertToRaw(editorState.getCurrentContent());
            const markup = draftToHtml(rawContentState);
            this.props.onChange(markup ? markup.split("\n").join("") : "")
        })
      
    };
 

    insertImage = (url) => {
        const { editorState } = this.state
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity(
            'IMAGE',
            'IMMUTABLE',
            { src: url })
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
        return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, '');
    };

    imageUploadCallBack = (file) => {

        return new Promise(
            (resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                let img = new Image();
                reader.onload = function (e) {
                    img.src = this.result
                }
                img.onload = function () {
                    let canvas = document.createElement('canvas');
                    let context = canvas.getContext('2d');
                    let originWidth = this.width;
                    let originHeight = this.height;
                    let maxWidth = 400;
                    let maxHeight = 500;
                    let targetWidth = originWidth;
                    let targetHeight = originHeight;
                    // Image size exceeds 300x300 limit
                    if (originWidth > maxWidth || originHeight > maxHeight) {
                        if (originWidth / originHeight > maxWidth / maxHeight) {
                            // wider, size limited by width
                            targetWidth = maxWidth;
                            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                        } else {
                            targetHeight = maxHeight;
                            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                        }
                    }
                    // canvas scales the image
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    // clear the canvas
                    context.clearRect(0, 0, targetWidth, targetHeight);
                    // Image Compression 
                    context.drawImage(img, 0, 0, targetWidth, targetHeight);

                    let newUrl = canvas.toDataURL('image/jpeg', 0.92);//base64 format

                    resolve({
                        data: {
                            link: newUrl
                        }
                    })
                }
            }
        );
    }


    render() {
        // const { editorState } = this.state;
        // let content = convertFromRaw(editorState);
        let editorState = this.state.editorState;

        return (<div style={{
            direction: 'ltr',
            // border: '1px solid black',
            // borderRadius: 10,
            padding: 10,
            margin: 10,
            height: this.props.height ?? 500,
            overflow: 'scroll',
            background: 'white'
        }}>
            <Editor
                editorState={editorState}
                onEditorStateChange={this.onEditorStateChange}
                // toolbarHidden
                wrapperClassName="wrapper-class"
                editorClassName="editor-class"
                toolbarClassName="toolbar-class"
                toolbar={{
                    options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'image', 'remove', 'history'],
                    lineHeight: { inDropdown: false },
                    textAlign: { inDropdown: true },
                    link: { inDropdown: true },
                    //   history: { inDropdown: true },
                    image: {
                        urlEnabled: false,
                        uploadEnabled: true,
                        alignmentEnabled: true, // Whether to display the arrange button is equivalent to text-align
                        uploadCallback: this.imageUploadCallBack,
                        previewImage: true,
                        inputAccept: 'image/*',
                        alt: { present: false, mandatory: false }

                        //  uploadCallback: this.imageUploadCallBack, alt: { present: true, mandatory: true }
                    },
                }}
            // onChange={() => { if (this.props.topMenu) this.createTopMenu() }}
            />
            <ImageSlicer
                src={this.state.oldSrc}
                close={() => { this.setState({ oldSrc: null }) }}
                title={this.props.getText(13594)}
                textButton={this.props.getText(13595)}
                newImg={(e) => { this.setState({ oldSrc: null }, () => { this.onEditorStateChange(this.insertImage(e)) }) }}
            />
        </div>)
    }
}

export default EditorContainer;